import {
	GTFS_TABLES_FETCH_PENDING,
	GTFS_TABLES_FETCH_SUCCESS,
	GTFS_TABLES_FETCH_FAILED
} from '../../util/constant';
import api from '../../util/api';
import appURLConstant from '../../util/appURLConstants';
import _ from 'lodash';

export const fetchGtfsData = async (tblkey, dispatch) => {
	try {
		dispatch({
			type: GTFS_TABLES_FETCH_PENDING
		});
		const response = await api.post(
			`${appURLConstant.REACT_GET_GTFS_DATA_URL}`,
			tblkey
		);
		const results =
			response.data.orbitResponse.statusCode === 400 ||
			!_.isEmpty(response.data.orbitResponse.errorMessage)
				? []
				: response.data.orbitResponse.body;

		dispatch({
			type: GTFS_TABLES_FETCH_SUCCESS,
			payload: results
		});
	} catch (error) {
		dispatch({
			type: GTFS_TABLES_FETCH_FAILED,
			payload: error
		});
	}
};
